import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/public/Home";
import BlogList from "@/pages/public/BlogList";
import BlogArticle from "@/pages/public/BlogArticle";

import Login from "@/pages/admin/Login";
import AdminLayout from "@/components/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import PortfolioAdmin from "@/pages/admin/PortfolioAdmin";
import LogosAdmin from "@/pages/admin/LogosAdmin";
import LeadsAdmin from "@/pages/admin/LeadsAdmin";
import BlogAdmin from "@/pages/admin/BlogAdmin";
import SettingsAdmin from "@/pages/admin/SettingsAdmin";

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" theme="dark" richColors />
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/blog" element={<BlogList />} />
            <Route path="/blog/:slug" element={<BlogArticle />} />

            <Route path="/admin/login" element={<Login />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="portfolio" element={<PortfolioAdmin />} />
              <Route path="logos" element={<LogosAdmin />} />
              <Route path="leads" element={<LeadsAdmin />} />
              <Route path="blog" element={<BlogAdmin />} />
              <Route path="settings" element={<SettingsAdmin />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
